// SPDX-License-Identifier: AGPL-3.0-or-later
// @ts-nocheck — canvas drawing code ported verbatim from the approved design previews.


  const TAU = Math.PI * 2, DPR = 2, S = 220, C = S / 2, AR = 50;
  const rand = (a, b) => a + Math.random() * (b - a);
  const lerp = (a, b, k) => a + (b - a) * k;
  const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
  const easeIO = (k) => (k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);
  const grad = (g, x0, y0, x1, y1, st) => { const r = g.createLinearGradient(x0, y0, x1, y1); st.forEach(([o, c]) => r.addColorStop(o, c)); return r; };
  const radial = (g, x, y, r0, r1, st, fx = x, fy = y) => { const r = g.createRadialGradient(fx, fy, r0, x, y, r1); st.forEach(([o, c]) => r.addColorStop(o, c)); return r; };
  function off(w, h) { const c = document.createElement('canvas'); c.width = Math.ceil(w * DPR); c.height = Math.ceil(h * DPR); const g = c.getContext('2d'); g.scale(DPR, DPR); c.w = w; c.h = h; return [c, g]; }
  function glow(g, x, y, r, rgb, a = 1) {
    g.save(); g.globalCompositeOperation = 'lighter';
    g.fillStyle = radial(g, x, y, 0, r, [[0, `rgba(${rgb},${a})`], [.3, `rgba(${rgb},${a * .4})`], [1, `rgba(${rgb},0)`]]);
    g.fillRect(x - r, y - r, r * 2, r * 2); g.restore();
  }
  // Critically-damped spring toward a target: smooth, never snappy.
  function spring(s, key, target, stiff = 3.2, dt = 1 / 60) {
    const v = (s[key + 'V'] || 0), x = (s[key] || 0);
    const a = stiff * stiff * (target - x) - 2 * stiff * v;
    s[key + 'V'] = v + a * dt; s[key] = x + s[key + 'V'] * dt; return s[key];
  }
  function sparkle(g, x, y, size, a, col = '255,255,255') {
    if (a < .02) return;
    g.save(); g.globalCompositeOperation = 'lighter'; g.globalAlpha = a;
    g.fillStyle = grad(g, x, y - size, x, y + size, [[0, `rgba(${col},0)`], [.5, `rgba(${col},1)`], [1, `rgba(${col},0)`]]); g.fillRect(x - .5, y - size, 1, size * 2);
    g.fillStyle = grad(g, x - size, y, x + size, y, [[0, `rgba(${col},0)`], [.5, `rgba(${col},1)`], [1, `rgba(${col},0)`]]); g.fillRect(x - size, y - .5, size * 2, 1);
    g.restore(); glow(g, x, y, size * .7, col, a * .6);
  }
  // Pre-rendered blurred silhouette used as a soft drop shadow (cheap at draw time).
  function shadowOf(sp, blur = 2) { const [c, g] = off(sp.w, sp.h); g.filter = `blur(${blur}px) brightness(0)`; g.drawImage(sp, 0, 0, sp.w, sp.h); Object.assign(c, {ox: sp.ox, oy: sp.oy, o: sp.o, sz: sp.sz}); return c; }

  /* ================= sprites ================= */
  // Realistic flight feather: curved rachis, asymmetric vanes made of hundreds of barbs, splits and down at the base.
  function featherSprite(len, wid, palette) {
    const W = wid * 2 + 6, [c, g] = off(W, len + 6), cx = W / 2, by = len + 3;
    const bend = wid * .25;
    const shaft = (u) => [cx + Math.sin(u * Math.PI * .9) * bend * .5, by - u * len];
    const edgeL = (u) => { const [x, y] = shaft(u); return [x - wid * .62 * Math.sin(Math.PI * Math.min(1, u * 1.05 + .08)) ** .7, y]; };
    const edgeR = (u) => { const [x, y] = shaft(u); return [x + wid * 1.0 * Math.sin(Math.PI * Math.min(1, u * 1.02 + .06)) ** .6, y]; };
    const path = new Path2D(); path.moveTo(...shaft(0));
    for (let u = 0; u <= 1.001; u += .02) path.lineTo(...edgeL(u));
    for (let u = 1; u >= -0.001; u -= .02) path.lineTo(...edgeR(u));
    path.closePath();
    g.save(); g.clip(path);
    g.fillStyle = grad(g, 0, by, 0, by - len, [[0, palette[0]], [.45, palette[1]], [1, palette[2]]]); g.fillRect(0, 0, W, len + 6);
    g.lineWidth = .32;
    for (let u = .04; u < 1; u += .011) {
      const [sx, sy] = shaft(u), split = Math.random() < .04;
      for (const side of [-1, 1]) {
        const e = side < 0 ? edgeL(Math.min(1, u + .06)) : edgeR(Math.min(1, u + .05));
        g.strokeStyle = side < 0 ? palette[3] : palette[4];
        g.globalAlpha = split ? .05 : .55;
        g.beginPath(); g.moveTo(sx, sy); g.quadraticCurveTo((sx + e[0]) / 2, sy - 2, e[0], e[1] - 1.5); g.stroke();
      }
    }
    g.globalAlpha = 1;
    g.fillStyle = grad(g, cx - wid, 0, cx + wid, 0, [[0, 'rgba(0,0,0,.18)'], [.45, 'rgba(0,0,0,0)'], [.7, 'rgba(255,255,255,.12)'], [1, 'rgba(0,0,0,.15)']]); g.fillRect(0, 0, W, len + 6);
    g.restore();
    g.strokeStyle = palette[5]; g.lineCap = 'round';
    for (let u = 0; u < .97; u += .03) { const [x0, y0] = shaft(u), [x1, y1] = shaft(u + .03); g.lineWidth = 1.3 * (1 - u) + .25; g.beginPath(); g.moveTo(x0, y0); g.lineTo(x1, y1); g.stroke(); }
    g.strokeStyle = palette[6]; g.lineWidth = .4;
    for (let i = 0; i < 14; i++) { const [x, y] = shaft(rand(0, .12)); g.beginPath(); g.moveTo(x, y); g.quadraticCurveTo(x + rand(-6, 6), y - rand(2, 6), x + rand(-wid, wid), y - rand(4, 10)); g.stroke(); }
    c.ox = cx; c.oy = by; c.sh = shadowOf(c, 1.6); return c;
  }
  const ANGEL = ['#c7d3e8', '#f6f8fc', '#ffffff', 'rgba(150,165,195,.75)', 'rgba(175,188,212,.7)', 'rgba(205,190,150,.95)', 'rgba(255,255,255,.75)'];
  const ANGEL_TIP = ['#c9d8f0', '#f4f9ff', '#dff2ff', 'rgba(160,170,195,.7)', 'rgba(190,195,215,.6)', 'rgba(214,190,130,.95)', 'rgba(255,255,255,.75)'];

  /* ================= decorations ================= */
  const DECOS = [];

  // ---------- shared stylised wing: bone curve + three ordered feather rows = one coherent silhouette ----------
  const D2R = Math.PI / 180;
  function quad(p0, p1, p2, u) { const v = 1 - u; return [v * v * p0[0] + 2 * v * u * p1[0] + u * u * p2[0], v * v * p0[1] + 2 * v * u * p1[1] + u * u * p2[1]]; }
  function featherPath(L, len, w) {          // smooth leaf-shaped feather pointing along +y
    L.beginPath(); L.moveTo(0, 0);
    L.bezierCurveTo(w, len * .15, w * .9, len * .7, 0, len);
    L.bezierCurveTo(-w * .7, len * .7, -w * .8, len * .15, 0, 0); L.closePath();
  }
  function wingFan(b, t, s, k, side, pal) {
    const flap = Math.sin(t * 1.3) * .05 * k + Math.sin(t * 1.0) * .015;
    b.save(); b.translate(C + side * 28, C - 4); b.scale(side, 1); b.rotate(-flap);
    // Bone (leading edge): folded hangs down beside the avatar, open sweeps up and out.
    const fold = [[0, 0], [13, 12], [19, 28]], open = [[0, 0], [14, -12], [31, -27]];
    const P = (u) => { const a = quad(...fold, u), o = quad(...open, u); return [lerp(a[0], o[0], k), lerp(a[1], o[1], k)]; };
    const dirAt = (u) => lerp(lerp(96, 82, u), lerp(108, -18, Math.pow(u, .85)), k) * D2R;   // feather direction (90 = down)
    const rows = [
      {n: 10, u0: .18, u1: 1, len: (u) => lerp(15, 26, Math.sin(u * Math.PI * .62)), w: 4, c: pal.prim},
      {n: 9, u0: .06, u1: .9, len: (u) => lerp(11, 19, Math.sin(u * Math.PI * .6)), w: 4.4, c: pal.sec},
      {n: 8, u0: 0, u1: .82, len: (u) => lerp(7, 10, u), w: 4.2, c: pal.cov},
    ];
    for (const r of rows) for (let i = 0; i < r.n; i++) {
      const u = lerp(r.u0, r.u1, i / (r.n - 1)), [x, y] = P(u), ang = dirAt(u) + Math.sin(t * 1.4 + i * .6) * .02 * k;
      const len = r.len(u) * lerp(.82, 1, k);
      b.save(); b.translate(x, y); b.rotate(ang - Math.PI / 2);
      featherPath(b, len, r.w);
      b.fillStyle = grad(b, 0, 0, 0, len, [[0, r.c[0]], [.6, r.c[1]], [1, r.c[2]]]); b.fill();
      b.strokeStyle = pal.line; b.lineWidth = .55; b.stroke();
      b.strokeStyle = pal.vein; b.lineWidth = .4; b.beginPath(); b.moveTo(0, len * .08); b.lineTo(0, len * .8); b.stroke();
      b.restore();
    }
    // Leading-edge highlight ties the rows into one wing.
    b.lineCap = 'round';
    b.strokeStyle = grad(b, 0, 0, 31, -27, [[0, pal.edge[0]], [1, pal.edge[1]]]); b.lineWidth = 3;
    b.beginPath(); for (let u = 0; u <= 1.001; u += .05) { const [x, y] = P(u); u ? b.lineTo(x, y) : b.moveTo(x, y); } b.stroke();
    b.globalCompositeOperation = 'lighter'; b.strokeStyle = pal.shine; b.lineWidth = 1;
    b.beginPath(); for (let u = 0; u <= 1.001; u += .05) { const [x, y] = P(u); u ? b.lineTo(x, y - .8) : b.moveTo(x, y - .8); } b.stroke();
    b.restore();
    glow(b, C + side * 46, C + lerp(14, -24, k), 30, pal.glow, .14 + .26 * k);
  }
  const ANGEL_PAL = {
    prim: ['#cfe0f7', '#f2f7ff', '#ffffff'], sec: ['#d8e6f8', '#f6faff', '#ffffff'], cov: ['#e6eefb', '#fbfdff', '#ffffff'],
    line: 'rgba(110,140,190,.6)', vein: 'rgba(150,175,215,.55)', edge: ['#ffffff', '#dbe9ff'], shine: 'rgba(255,255,255,.8)', glow: '190,225,255'};
  const PHOENIX_PAL = {
    prim: ['#ffd36a', '#ff8a2a', '#e8380f'], sec: ['#ffe08a', '#ffa43a', '#f05a1a'], cov: ['#fff0b0', '#ffc65a', '#ff8a2a'],
    line: 'rgba(130,30,0,.65)', vein: 'rgba(160,50,0,.5)', edge: ['#fff4c8', '#ffb23a'], shine: 'rgba(255,240,200,.8)', glow: '255,140,40'};

  // Keep front-layer pieces on the rim: clear the avatar interior with a soft edge.
  function rimCut(L, inset = 7) {
    L.save(); L.globalCompositeOperation = 'destination-out';
    L.fillStyle = radial(L, C, C, AR - inset - 6, AR - inset, [[0, 'rgba(0,0,0,1)'], [1, 'rgba(0,0,0,0)']]);
    L.beginPath(); L.arc(C, C, AR - inset, 0, TAU); L.fill(); L.restore();
  }

  // ---------- 1. Angel wings ----------
  DECOS.push({ group: 'back', name: 'Melek Kanatları', hint: 'Üzerine gel: yavaşça açılır', bound: 1.4,
    init(s) {
      s.prim = Array.from({length: 4}, () => featherSprite(rand(62, 70), 7.5, ANGEL_TIP));
      s.sec = Array.from({length: 4}, () => featherSprite(rand(42, 48), 8.5, ANGEL));
      s.cov = Array.from({length: 3}, () => featherSprite(rand(24, 28), 7.5, ANGEL));
    },
    draw(b, f, t, s) {
      const k = easeIO(clamp(spring(s, 'k', s.hover ? 1 : 0, 2.6)));
      wingFan(b, t, s, k, -1, ANGEL_PAL); wingFan(b, t, s, k, 1, ANGEL_PAL);
      for (let i = 0; i < 4; i++) { const a = Math.max(0, Math.sin(t * .8 + i * 1.9)) ** 14;
        sparkle(b, C + (i % 2 ? 1 : -1) * (54 + i * 2), C - 50 + i * 6, 3.5, a * k, '220,240,255'); }
    } });

  // ---------- 2. Phoenix wings ----------
  const PHOENIX = ['#7a1a05', '#ff6a1a', '#ffd36a', 'rgba(140,30,0,.7)', 'rgba(255,170,60,.6)', 'rgba(255,230,160,.95)', 'rgba(255,200,120,.7)'];
  const PHOENIX_TIP = ['#9a2006', '#ff8a2a', '#fff0b0', 'rgba(150,40,0,.7)', 'rgba(255,190,80,.6)', 'rgba(255,240,180,.95)', 'rgba(255,210,140,.7)'];
  DECOS.push({ group: 'back', name: 'Anka Kanatları', hint: 'Üzerine gel: alev kanatlar açılır', bound: 1.4,
    init(s) {
      s.prim = Array.from({length: 4}, () => featherSprite(rand(62, 70), 7.5, PHOENIX_TIP));
      s.sec = Array.from({length: 4}, () => featherSprite(rand(42, 48), 8.5, PHOENIX));
      s.cov = Array.from({length: 3}, () => featherSprite(rand(24, 28), 7.5, PHOENIX));
      s.e = [];
    },
    draw(b, f, t, s) {
      const k = easeIO(clamp(spring(s, 'k', s.hover ? 1 : 0, 2.6)));
      glow(b, C, C - 6, 64, '255,110,30', .22 + .18 * k);
      wingFan(b, t, s, k, -1, PHOENIX_PAL); wingFan(b, t, s, k, 1, PHOENIX_PAL);
      // Embers lifting off the feathers.
      if (Math.random() < .25 + .35 * k) { const side = Math.random() < .5 ? -1 : 1; s.e.push({x: C + side * rand(42, 58), y: C - rand(0, 40), life: 0, max: rand(1.4, 2.4), ph: rand(0, 6)}); }
      s.e = s.e.filter((e) => (e.life += 1 / 60) < e.max);
      f.save(); f.globalCompositeOperation = 'lighter';
      for (const e of s.e) { const q = e.life / e.max; const x = e.x + Math.sin(t * 1.6 + e.ph) * 2, y = e.y - q * 16;
        f.fillStyle = `rgba(255,${190 - 80 * q | 0},90,${(1 - q) * (.6 + .4 * Math.sin(t * 7 + e.ph))})`; f.beginPath(); f.arc(x, y, .9, 0, TAU); f.fill(); }
      f.restore();
    } });

  // ---------- 3. Cat ears ----------
  function earSprite() {
    const [c, g] = off(60, 70); g.translate(30, 66);
    const outer = new Path2D('M-26,0 C-26,-30 -14,-52 -3,-64 C2,-62 8,-56 12,-46 C20,-28 26,-14 26,0 Z');
    g.save(); g.clip(outer);
    g.fillStyle = grad(g, 0, 0, 0, -64, [[0, '#8a4a22'], [.5, '#cf7d3a'], [1, '#f0a85e']]); g.fillRect(-30, -70, 60, 72);
    for (let i = 0; i < 520; i++) {
      const x = rand(-26, 26), y = rand(-64, 0), band = Math.sin(y * .35 + x * .05) > .55;
      g.strokeStyle = band ? 'rgba(110,50,15,.55)' : `rgba(${rand(230, 255) | 0},${rand(160, 200) | 0},${rand(100, 140) | 0},.5)`;
      g.lineWidth = rand(.3, .7); g.beginPath(); g.moveTo(x, y); g.quadraticCurveTo(x - x * .05, y - 2, x - x * .08 + rand(-1, 1), y - rand(3, 6)); g.stroke();
    }
    g.restore();
    g.strokeStyle = 'rgba(255,220,180,.6)'; g.lineWidth = .5;
    for (let i = 0; i < 70; i++) { const u = rand(0, 1); const x = lerp(-26, -3, u) + rand(-1, 1), y = -Math.sin(u * Math.PI / 2) * 60; g.beginPath(); g.moveTo(x, y); g.lineTo(x - rand(1, 3), y - rand(1, 3)); g.stroke(); }
    const inner = new Path2D('M-15,-2 C-15,-22 -8,-40 -2,-50 C5,-40 13,-22 14,-2 Z');
    g.fillStyle = radial(g, 0, -10, 2, 46, [[0, '#7a3a44'], [.45, '#d27c8c'], [1, '#f6b3bf']]); g.fill(inner);
    g.save(); g.clip(inner); g.fillStyle = grad(g, -15, 0, 15, 0, [[0, 'rgba(60,20,25,.45)'], [.5, 'rgba(0,0,0,0)'], [1, 'rgba(60,20,25,.35)']]); g.fillRect(-16, -52, 32, 52); g.restore();
    g.strokeStyle = 'rgba(255,250,245,.85)';
    for (let i = 0; i < 60; i++) { const sd = i % 2 ? 1 : -1, y = rand(-30, -2), x = sd * rand(8, 14);
      g.lineWidth = rand(.35, .7); g.beginPath(); g.moveTo(x, y); g.quadraticCurveTo(x * .5, y - rand(4, 8), sd * rand(0, 4), y - rand(10, 18)); g.stroke(); }
    c.ox = 30; c.oy = 66; c.sh = shadowOf(c, 2); return c;
  }
  DECOS.push({ group: 'back', name: 'Kedi Kulakları', hint: 'Üzerine gel: dikleşir',
    init(s) { s.ear = earSprite(); s.next = [rand(3, 6), rand(4, 8)]; },
    draw(b, f, t, s) {
      const perk = spring(s, 'p', s.hover ? 1 : 0, 2.2);
      [-1, 1].forEach((side, i) => {
        s.next[i] -= 1 / 60; if (s.next[i] <= 0) { s['tw' + i + 'V'] = (s['tw' + i + 'V'] || 0) + rand(4, 6); s.next[i] = rand(1.8, 4.5); }
        const tw = spring(s, 'tw' + i, 0, 5);
        const sway = Math.sin(t * .9 + i * 2) * .07 + Math.sin(t * 1.7 + i) * .025;
        const ang = side * (.36 - .16 * perk) + side * tw * .22 + sway;
        b.save(); b.translate(C + side * 25, C - 27); b.rotate(ang); b.scale(side * .5 * (1 + .03 * perk), .5 * (1 + .05 * perk));
        b.globalAlpha = .35; b.drawImage(s.ear.sh, -s.ear.ox + 1, -s.ear.oy + 3, s.ear.w, s.ear.h); b.globalAlpha = 1;
        b.drawImage(s.ear, -s.ear.ox, -s.ear.oy, s.ear.w, s.ear.h);
        b.restore();
      });
    } });

  // ---------- 4. Kitsune tails ----------
  function tailSprite() {
    const [c, g] = off(84, 124); g.translate(42, 120);
    const spine = (u) => [Math.sin(u * 2.2) * 18 * u, -u * 96];
    const rad = (u) => 4 + 24 * Math.sin(Math.PI * Math.min(1, u * 1.04)) ** .7 * (1 - u * .25);
    // Soft body underneath the strands so the tail reads as one fluffy volume.
    for (let u = 0; u <= 1; u += .02) { const [x, y] = spine(u), r = rad(u) * .8;
      g.fillStyle = radial(g, x, y, 0, r, [[0, u > .74 ? 'rgba(255,246,236,.9)' : 'rgba(236,120,52,.9)'], [1, u > .74 ? 'rgba(255,246,236,0)' : 'rgba(236,120,52,0)']]);
      g.fillRect(x - r, y - r, r * 2, r * 2); }
    for (let i = 0; i < 2600; i++) {
      const u = Math.pow(Math.random(), .9), [x, y] = spine(u), r = rad(u) * rand(.2, 1.05), a = rand(-1, 1);
      const tip = u > .74;
      g.strokeStyle = tip ? `rgba(255,${rand(244, 255) | 0},${rand(230, 250) | 0},.6)` : `rgba(${rand(225, 255) | 0},${rand(110, 150) | 0},${rand(40, 70) | 0},.45)`;
      g.lineWidth = rand(.4, .9); g.beginPath(); g.moveTo(x + a * r * .3, y); g.quadraticCurveTo(x + a * r * .8, y - 2, x + a * r, y - rand(2, 8)); g.stroke();
    }
    g.globalCompositeOperation = 'source-atop';
    g.fillStyle = grad(g, -20, 0, 20, 0, [[0, 'rgba(60,20,0,.25)'], [.55, 'rgba(255,255,255,0)'], [1, 'rgba(255,240,220,.15)']]); g.fillRect(-35, -120, 70, 124);
    c.ox = 42; c.oy = 120; c.sh = shadowOf(c, 2); return c;
  }
  DECOS.push({ group: 'back', name: 'Kitsune Kuyrukları', hint: 'Süzülen tilki kuyrukları',
    init(s) { s.tails = [0, 1, 2].map(() => tailSprite()); s.wisps = Array.from({length: 5}, (_, i) => ({ph: i * 1.3, a: -2.6 + i * .55})); },
    draw(b, f, t, s) {
      glow(b, C, C + 10, 64, '255,150,70', .16);
      const n = 6;
      for (let i = 0; i < n; i++) {
        const base = [-2.05, -1.6, -1.15, 1.15, 1.6, 2.05][i];
        const sway = Math.sin(t * .8 + i * .9) * .07 + Math.sin(t * .5 + i * 1.7) * .04;
        const sp = s.tails[i % 3];
        b.save(); b.translate(C, C + 8); b.rotate(base + sway); b.scale((base < 0 ? -1 : 1) * .58, .58);
        b.globalAlpha = .3; b.drawImage(sp.sh, -sp.ox + 2, -sp.oy + 3, sp.w, sp.h); b.globalAlpha = 1;
        b.drawImage(sp, -sp.ox, -sp.oy, sp.w, sp.h);
        b.restore();
      }
      for (const w of s.wisps) {
        const a = w.a + Math.sin(t * .4 + w.ph) * .15, r = 56 + Math.sin(t * .7 + w.ph) * 2;
        const x = C + Math.sin(a * 1.6) * r, y = C + 16 - Math.cos(a * 1.6) * r * .8, fl = .6 + .4 * Math.sin(t * 1.4 + w.ph);
        glow(f, x, y, 7, '120,200,255', .5 * fl); glow(f, x, y - 1, 3, '230,250,255', .9 * fl);
      }
    } });

  // ---------- 5. Morpho butterflies ----------
  function wingSprite() {
    const [c, g] = off(30, 34); g.translate(2, 17);
    const up = new Path2D('M0,0 C4,-14 18,-17 26,-12 C29,-6 22,-1 0,0 Z'), lo = new Path2D('M0,0 C10,2 18,8 15,15 C10,17 3,10 0,0 Z');
    for (const [p, cx, cy] of [[up, 14, -9], [lo, 9, 8]]) {
      g.fillStyle = radial(g, cx - 4, cy, 1, 18, [[0, '#d8f6ff'], [.3, '#3fc6ff'], [.7, '#1a5fe0'], [1, '#081a4a']]); g.fill(p);
      g.save(); g.clip(p); g.strokeStyle = 'rgba(10,20,60,.55)'; g.lineWidth = .4;
      for (let i = 0; i < 6; i++) { g.beginPath(); g.moveTo(0, 0); g.lineTo(cx * 2 * Math.cos((i - 2.5) * .3), cy * 2 * (1 + (i - 2.5) * .12)); g.stroke(); }
      g.restore();
      g.strokeStyle = '#06102e'; g.lineWidth = 1.2; g.stroke(p);
    }
    g.fillStyle = '#fff'; for (const [x, y] of [[22, -11], [24, -9], [13, 12]]) { g.beginPath(); g.arc(x, y, .7, 0, TAU); g.fill(); }
    c.oy = 17; return c;
  }
  function drawButterfly(L, x, y, ang, flap, sc, sp) {
    L.save(); L.translate(x, y); L.rotate(ang); L.scale(sc, sc);
    const open = .18 + .82 * Math.abs(Math.cos(flap));
    for (const side of [-1, 1]) { L.save(); L.scale(side * open, 1); L.drawImage(sp, -2 * 0, -sp.oy * 1, 30, 34); L.restore(); }
    L.fillStyle = '#0b0f1e'; L.beginPath(); L.ellipse(0, 1, 1.3, 7, 0, 0, TAU); L.fill();
    L.strokeStyle = '#0b0f1e'; L.lineWidth = .6; L.beginPath(); L.moveTo(0, -6); L.quadraticCurveTo(-2, -11, -4, -12); L.moveTo(0, -6); L.quadraticCurveTo(2, -11, 4, -12); L.stroke();
    L.restore();
  }
  DECOS.push({ group: 'back', name: 'Mavi Kelebekler', hint: 'Yanardöner Morpho kelebekleri',
    init(s) { s.sp = wingSprite(); s.trail = []; s.motes = Array.from({length: 10}, () => ({x: rand(-58, 58), y: rand(-58, 58), p: rand(0, 6), v: rand(.05, .12)})); },
    draw(b, f, t, s) {
      // Floating light motes around the avatar.
      for (const m of s.motes) { m.y -= m.v; if (m.y < -60) m.y = 60;
        const r = Math.hypot(m.x, m.y); if (r < AR + 2) continue;
        glow(f, C + m.x + Math.sin(t * .7 + m.p) * 2, C + m.y, 2.5, '150,220,255', .35 + .35 * Math.sin(t * 1.5 + m.p)); }
      const perched = [[-.85, .55, t * 1.1, .62, 2], [2.6, -1.9, t * .9 + 1.4, .5, 1]];
      for (const [a, ang, flap, sc, off] of perched) {
        const x = C + Math.cos(a) * (AR + off), y = C + Math.sin(a) * (AR + off);
        drawButterfly(f, x, y, ang, flap, sc, s.sp);
        const face = Math.abs(Math.cos(flap));                               // wings flat to the viewer catch the light
        f.save(); f.globalCompositeOperation = 'lighter'; f.globalAlpha = face * .35; drawButterfly(f, x, y, ang, flap, sc, s.sp); f.restore();
        if (Math.max(0, Math.sin(flap * .5)) ** 30 > .5) sparkle(f, x + rand(-6, 6), y + rand(-6, 6), 3, .8, '170,230,255');
      }
      const a = t * .45, fx = C - 38 + Math.cos(a) * 12, fy = C - 40 + Math.sin(a * 1.3) * 7;
      s.trail.push({x: fx, y: fy, life: 0}); s.trail = s.trail.filter((p) => (p.life += 1 / 60) < 1.1);
      f.save(); f.globalCompositeOperation = 'lighter';
      for (const p of s.trail) { const q = p.life / 1.1; f.fillStyle = `rgba(150,225,255,${.55 * (1 - q)})`; f.beginPath(); f.arc(p.x + Math.sin(p.life * 9) * 1.5, p.y + q * 6, .9 * (1 - q) + .3, 0, TAU); f.fill(); }
      f.restore();
      drawButterfly(f, fx, fy, Math.cos(a) * .4 - .3, t * 9, .42, s.sp);
      glow(f, fx, fy, 10, '90,200,255', .3);
    } });

  // ---------- 6. Hellfire (slow tongues hugging the rim) ----------
  DECOS.push({ group: 'front', name: 'Cehennem Ateşi', hint: 'Avatarı saran yavaş alevler',
    init(s) { s.p = []; s.e = []; },
    draw(b, f, t, s) {
      glow(b, C, C + 6, 64, '255,90,20', .28 + .05 * Math.sin(t * .9));
      for (let i = 0; i < 4; i++) {
        const a = rand(-.35, Math.PI + .35) * (Math.random() < .8 ? 1 : -1);    // mostly lower half and sides
        s.p.push({a, x: C + Math.cos(a) * (AR - 1), y: C + Math.sin(a) * (AR - 1), life: 0, max: rand(1.4, 2.2), w: rand(3, 5), h: rand(9, 15), ph: rand(0, 6)});
      }
      if (Math.random() < .05) { const a = rand(0, Math.PI); s.e.push({x: C + Math.cos(a) * AR, y: C + Math.sin(a) * AR, life: 0, max: rand(1.8, 2.6), ph: rand(0, 6)}); }
      s.p = s.p.filter((p) => (p.life += 1 / 60) < p.max);
      for (const L of [b, f]) { L.save(); L.globalCompositeOperation = 'lighter'; }
      for (const p of s.p) {
        const k = p.life / p.max, rise = k * 9;
        const nx = Math.cos(p.a), ny = Math.sin(p.a);
        const x = p.x + nx * 2.5 * k + Math.sin(t * 1.6 + p.ph) * 1.2, y = p.y + ny * 2.5 * k - rise;
        const env = Math.sin(Math.PI * Math.min(1, k * 1.4));                   // grow in, then shrink and fade
        const col = k < .25 ? '255,225,160' : k < .55 ? '255,140,40' : '210,55,15';
        const L = y < C - AR * .3 ? b : f;
        L.save(); L.translate(x, y); L.scale(1, p.h / p.w);
        L.fillStyle = radial(L, 0, p.w * .3, 0, p.w, [[0, `rgba(${col},${.42 * env})`], [.6, `rgba(${col},${.15 * env})`], [1, `rgba(${col},0)`]]);
        L.beginPath(); L.arc(0, 0, p.w, 0, TAU); L.fill(); L.restore();
      }
      s.e = s.e.filter((e) => (e.life += 1 / 60) < e.max);
      for (const e of s.e) { const k = e.life / e.max; const x = e.x + Math.sin(t * 1.5 + e.ph) * 2, y = e.y - k * 14;
        f.fillStyle = `rgba(255,200,110,${(1 - k) * (.6 + .4 * Math.sin(t * 6 + e.ph))})`; f.beginPath(); f.arc(x, y, .8, 0, TAU); f.fill(); }
      for (const L of [b, f]) L.restore();
      f.save(); f.globalCompositeOperation = 'destination-out'; f.fillStyle = radial(f, C, C, AR - 10, AR, [[0, 'rgba(0,0,0,1)'], [1, 'rgba(0,0,0,0)']]);
      f.beginPath(); f.arc(C, C, AR, 0, TAU); f.fill(); f.restore();
      b.save(); b.globalCompositeOperation = 'lighter'; b.strokeStyle = 'rgba(255,140,50,.55)'; b.lineWidth = 1.6; b.shadowColor = '#ff6a14'; b.shadowBlur = 8; b.beginPath(); b.arc(C, C, AR + .5, 0, TAU); b.stroke(); b.restore();
    } });

  // ---------- 7. Sakura garland (top-left, on the rim) ----------
  function blossom(r, open = 1) {
    const [c, g] = off(r * 2.6, r * 2.6); g.translate(r * 1.3, r * 1.3);
    for (let k = 0; k < 5; k++) { g.save(); g.rotate(k * TAU / 5 + .3);
      const pr = r * open;
      g.fillStyle = radial(g, 0, -pr * .2, 0, pr, [[0, '#d95f8c'], [.35, '#f6a9c4'], [.85, '#ffe4ee'], [1, '#fff6fa']]);
      g.beginPath(); g.moveTo(0, 0); g.bezierCurveTo(pr * .65, -pr * .3, pr * .55, -pr * .95, pr * .14, -pr * 1.02); g.lineTo(0, -pr * .88); g.lineTo(-pr * .14, -pr * 1.02);
      g.bezierCurveTo(-pr * .55, -pr * .95, -pr * .65, -pr * .3, 0, 0); g.fill();
      g.strokeStyle = 'rgba(200,80,120,.28)'; g.lineWidth = .35; g.beginPath(); g.moveTo(0, -pr * .1); g.lineTo(0, -pr * .7); g.stroke();
      g.restore(); }
    g.fillStyle = radial(g, 0, 0, 0, r * .35, [[0, '#ffd27a'], [1, 'rgba(255,170,120,0)']]); g.beginPath(); g.arc(0, 0, r * .35, 0, TAU); g.fill();
    g.strokeStyle = '#c0456c'; g.lineWidth = .4; g.fillStyle = '#ffe08a';
    for (let k = 0; k < 9; k++) { const a = k * TAU / 9; g.beginPath(); g.moveTo(0, 0); g.lineTo(Math.cos(a) * r * .42, Math.sin(a) * r * .42); g.stroke(); g.beginPath(); g.arc(Math.cos(a) * r * .44, Math.sin(a) * r * .44, .55, 0, TAU); g.fill(); }
    c.o = r * 1.3; c.sz = r * 2.6; c.sh = shadowOf(c, 1.4); return c;
  }
  DECOS.push({ group: 'front', name: 'Sakura Çelengi', hint: 'Sol üstte, tam kenarda',
    init(s) {
      s.fl = [blossom(7), blossom(6), blossom(5.2), blossom(4.2, .8)];
      s.items = []; const a0 = Math.PI * 1.02, a1 = Math.PI * 1.62;
      for (let i = 0; i < 11; i++) { const u = i / 10; s.items.push({a: lerp(a0, a1, u) + rand(-.03, .03), off: rand(-3, 3), sp: s.fl[(i * 7) % 4], rot: rand(0, TAU), sc: lerp(1.1, .75, Math.abs(u - .45) * 1.6)}); }
      s.leaves = Array.from({length: 9}, (_, i) => ({a: lerp(a0 - .05, a1 + .05, i / 8), side: i % 2 ? 1 : -1, l: rand(7, 10)}));
      s.petals = [];
    },
    draw(b, f, t, s) {
      const R = AR + 1.5, sway = (a) => Math.sin(t * .7 + a * 3) * .012;
      f.strokeStyle = grad(f, C - R, C - R, C, C, [[0, '#3b241f'], [1, '#5a3a30']]); f.lineCap = 'round';
      f.lineWidth = 3; f.beginPath(); f.arc(C, C, R, Math.PI * .98, Math.PI * 1.68); f.stroke();
      f.lineWidth = 1.2; for (const tw of [[1.15, -1], [1.42, 1], [1.58, -1]]) { const a = Math.PI * tw[0], x = C + Math.cos(a) * R, y = C + Math.sin(a) * R;
        f.beginPath(); f.moveTo(x, y); f.quadraticCurveTo(x + Math.cos(a) * 6, y + Math.sin(a) * 6, x + Math.cos(a + tw[1] * .6) * 11, y + Math.sin(a + tw[1] * .6) * 11); f.stroke(); }
      for (const l of s.leaves) { const a = l.a + sway(l.a), x = C + Math.cos(a) * R, y = C + Math.sin(a) * R;
        f.save(); f.translate(x, y); f.rotate(a + l.side * .9 + Math.PI / 2);
        f.fillStyle = grad(f, 0, 0, 0, -l.l, [[0, '#2f6a33'], [1, '#6fae5a']]); f.beginPath(); f.moveTo(0, 0); f.quadraticCurveTo(l.l * .45, -l.l * .5, 0, -l.l); f.quadraticCurveTo(-l.l * .45, -l.l * .5, 0, 0); f.fill();
        f.strokeStyle = 'rgba(20,50,20,.5)'; f.lineWidth = .3; f.beginPath(); f.moveTo(0, 0); f.lineTo(0, -l.l * .9); f.stroke(); f.restore(); }
      for (const it of s.items) { const a = it.a + sway(it.a), r = R + it.off, x = C + Math.cos(a) * r, y = C + Math.sin(a) * r;
        f.save(); f.translate(x, y); f.rotate(it.rot + Math.sin(t * .8 + it.rot * 3) * .14);
        const br = 1 + Math.sin(t * 1.1 + it.rot * 2) * .06; f.scale(br, br);
        const z = it.sp.sz * it.sc; f.globalAlpha = .35; f.drawImage(it.sp.sh, -it.sp.o * it.sc, -it.sp.o * it.sc + 1, z, z); f.globalAlpha = 1;
        f.drawImage(it.sp, -it.sp.o * it.sc, -it.sp.o * it.sc, z, z); f.restore(); }
      if (Math.random() < .012) { const a = rand(Math.PI * 1.05, Math.PI * 1.6); s.petals.push({x: C + Math.cos(a) * R, y: C + Math.sin(a) * R, r: rand(0, 6), life: 0}); }
      s.petals = s.petals.filter((p) => (p.life += 1 / 60) < 5);
      for (const p of s.petals) { p.y += .22; p.x -= .1 + Math.sin(t * .8 + p.r) * .12; p.r += .015;
        f.save(); f.globalAlpha = 1 - p.life / 5; f.translate(p.x, p.y); f.rotate(p.r); f.scale(Math.cos(p.r * 2), 1); f.fillStyle = '#ffc1d6'; f.beginPath(); f.ellipse(0, 0, 2.6, 1.6, 0, 0, TAU); f.fill(); f.restore(); }
    } });

  // ---------- 8. Royal crown ----------
  function crownSprite() {
    const [c, g] = off(90, 60); g.translate(45, 50);
    const gold = (y0, y1) => grad(g, 0, y0, 0, y1, [[0, '#fff3b8'], [.25, '#f2c75a'], [.55, '#a8761f'], [.8, '#e9b84a'], [1, '#6e4a12']]);
    const body = new Path2D('M-38,0 L-40,-18 L-28,-10 L-22,-34 L-11,-14 L0,-42 L11,-14 L22,-34 L28,-10 L40,-18 L38,0 Z');
    g.fillStyle = gold(-42, 0); g.fill(body);
    g.save(); g.clip(body); g.fillStyle = grad(g, -40, 0, 40, 0, [[0, 'rgba(0,0,0,.35)'], [.3, 'rgba(255,255,255,.15)'], [.55, 'rgba(0,0,0,0)'], [1, 'rgba(0,0,0,.4)']]); g.fillRect(-45, -45, 90, 50);
    g.strokeStyle = 'rgba(120,80,20,.6)'; g.lineWidth = .6; for (let i = -3; i <= 3; i++) { g.beginPath(); g.moveTo(i * 9, -2); g.quadraticCurveTo(i * 9 + 4, -8, i * 9, -12); g.stroke(); }
    g.restore();
    g.strokeStyle = '#fff3c4'; g.lineWidth = .7; g.stroke(body);
    g.fillStyle = gold(-8, 4); g.beginPath(); g.roundRect(-40, -7, 80, 9, 2); g.fill();
    g.strokeStyle = 'rgba(255,240,190,.8)'; g.lineWidth = .5; g.stroke();
    for (const [x, y] of [[-22, -34], [0, -42], [22, -34], [-40, -18], [40, -18]]) { g.fillStyle = radial(g, x - .8, y - 1.2, 0, 3, [[0, '#ffffff'], [.5, '#f1ece0'], [1, '#bdb3a0']]); g.beginPath(); g.arc(x, y - 2, 2.6, 0, TAU); g.fill(); }
    const gem = (x, y, r, light, dark) => { g.fillStyle = radial(g, x - r * .3, y - r * .3, 0, r, [[0, '#fff'], [.25, light], [1, dark]]); g.beginPath();
      for (let i = 0; i < 6; i++) { const a = i * TAU / 6 + Math.PI / 6; g.lineTo(x + Math.cos(a) * r, y + Math.sin(a) * r); } g.closePath(); g.fill();
      g.strokeStyle = 'rgba(255,230,160,.9)'; g.lineWidth = .6; g.stroke(); };
    gem(0, -3, 4.2, '#ff5a7a', '#6a0018'); gem(-20, -3, 2.8, '#5aa8ff', '#0a2a6a'); gem(20, -3, 2.8, '#5aa8ff', '#0a2a6a'); gem(0, -24, 3, '#59f0a0', '#0a5a34');
    c.ox = 45; c.oy = 50; c.sh = shadowOf(c, 2.5); return c;
  }
  DECOS.push({ group: 'front', name: 'Kraliyet Tacı', hint: 'Sol üstte taç, parıldayan altın çerçeve',
    init(s) { s.crown = crownSprite(); },
    draw(b, f, t, s) {
      // Gold frame: bevelled double band with engraved dots and a row of pearls.
      const R = AR + 3;
      f.save();
      for (const [r, w, st] of [[R + 1.8, 1.2, [[0, '#7a5012'], [.5, '#ffe9a6'], [1, '#8a5d14']]], [R, 2.6, [[0, '#a8761f'], [.3, '#fff3c4'], [.55, '#d9a640'], [.8, '#fff0b8'], [1, '#8a5d14']]], [R - 2, .8, [[0, '#6e4a12'], [1, '#e2b450']]]]) {
        f.strokeStyle = grad(f, C - R, C - R, C + R, C + R, st); f.lineWidth = w; f.beginPath(); f.arc(C, C, r, 0, TAU); f.stroke();
      }
      f.fillStyle = 'rgba(110,70,15,.75)';
      for (let i = 0; i < 40; i++) { const a = i * TAU / 40; f.beginPath(); f.arc(C + Math.cos(a) * R, C + Math.sin(a) * R, .45, 0, TAU); f.fill(); }
      for (let i = 0; i < 24; i++) { const a = i * TAU / 24 + TAU / 48, x = C + Math.cos(a) * (R + 4.2), y = C + Math.sin(a) * (R + 4.2);
        f.fillStyle = radial(f, x - .4, y - .4, 0, 1.4, [[0, '#ffffff'], [.6, '#efe7d6'], [1, '#b8ad98']]); f.beginPath(); f.arc(x, y, 1.15, 0, TAU); f.fill(); }
      // Two glints chasing each other around the frame.
      f.globalCompositeOperation = 'lighter';
      for (const [sp, off] of [[.45, 0], [.45, Math.PI]]) {
        const a = t * sp + off;
        for (let k = 0; k < 14; k++) { f.strokeStyle = `rgba(255,245,210,${.5 * (1 - k / 14)})`; f.lineWidth = 2.4; f.beginPath(); f.arc(C, C, R, a - k * .025, a - k * .025 + .025); f.stroke(); }
        sparkle(f, C + Math.cos(a) * R, C + Math.sin(a) * R, 4.5, .9, '255,250,225');
      }
      f.restore();
      // Crown seated on the top-left of the rim, tilted with the curve.
      const cr = s.crown, ang = -2.36, sc = .52, x = C + Math.cos(ang) * (AR - 2), y = C + Math.sin(ang) * (AR - 2), rot = ang + Math.PI / 2;
      glow(b, x, y, 30, '255,210,120', .28);
      f.save(); f.translate(x, y); f.rotate(rot + Math.sin(t * .8) * .015); f.scale(sc, sc);
      f.globalAlpha = .4; f.drawImage(cr.sh, -cr.ox, -cr.oy + 4, cr.w, cr.h); f.globalAlpha = 1;
      f.drawImage(cr, -cr.ox, -cr.oy, cr.w, cr.h);
      const sx = ((t * .22) % 1.6 - .3) * 100 - 50;
      f.save(); f.globalCompositeOperation = 'source-atop';
      f.fillStyle = grad(f, sx - 12, 0, sx + 12, 0, [[0, 'rgba(255,255,255,0)'], [.5, 'rgba(255,250,225,.55)'], [1, 'rgba(255,255,255,0)']]); f.fillRect(-45, -50, 90, 60);
      f.restore(); f.restore();
      [[0, -42], [-22, -34], [22, -34], [0, -3]].forEach(([dx, dy], i) => {
        const a = Math.max(0, Math.sin(t * .8 + i * 1.7)) ** 18;
        sparkle(f, x + (dx * Math.cos(rot) - dy * Math.sin(rot)) * sc, y + (dx * Math.sin(rot) + dy * Math.cos(rot)) * sc, 4, a, '255,248,225');
      });
    } });

  // ---------- 9. Golden laurel ----------
  function leafSprite() {
    const [c, g] = off(10, 18); g.translate(5, 17);
    const p = new Path2D('M0,0 C4,-4 4.5,-11 0,-16 C-4.5,-11 -4,-4 0,0 Z');
    g.fillStyle = grad(g, -4, 0, 4, -16, [[0, '#8a5d14'], [.35, '#f7d77a'], [.55, '#fff2c2'], [.75, '#d6a43a'], [1, '#7a5012']]); g.fill(p);
    g.strokeStyle = 'rgba(110,70,10,.7)'; g.lineWidth = .4; g.beginPath(); g.moveTo(0, 0); g.lineTo(0, -15); g.stroke();
    g.strokeStyle = 'rgba(255,240,190,.7)'; g.stroke(p);
    c.ox = 5; c.oy = 17; return c;
  }
  DECOS.push({ group: 'front', name: 'Altın Defne', hint: 'Kenara oturan altın çelenk',
    init(s) { s.leaf = leafSprite(); },
    draw(b, f, t, s) {
      const R = AR + 2, L = s.leaf;
      for (const side of [-1, 1]) {
        f.strokeStyle = grad(f, C, C + R, C + side * R, C - R * .4, [[0, '#7a5012'], [.5, '#e9c25e'], [1, '#8a5d14']]); f.lineWidth = 1.6;
        f.beginPath(); f.arc(C, C, R, Math.PI / 2 + side * .12, Math.PI / 2 + side * 2.3, side < 0); f.stroke();
        for (let i = 0; i < 9; i++) {
          const a = Math.PI / 2 + side * (.25 + i * .23), x = C + Math.cos(a) * R, y = C + Math.sin(a) * R, sc = 1 - i * .045;
          for (const out of [1, -1]) {
            f.save(); f.translate(x, y); f.rotate(a + Math.PI / 2 * side + Math.PI / 2 + (out > 0 ? -.5 : .5) + Math.sin(t * 1.1 + i * .8 + (out > 0 ? 0 : 1.6) + side) * .09);
            f.scale(sc * (out > 0 ? 1 : .85), sc * (out > 0 ? 1 : .85));
            f.drawImage(L, -L.ox, -L.oy, L.w, L.h);
            const shine = Math.max(0, Math.sin(t * 1.2 - i * .55 + (side > 0 ? 0 : Math.PI))) ** 8;
            if (shine > .02) { f.globalCompositeOperation = 'lighter'; f.globalAlpha = shine * .55; f.drawImage(L, -L.ox, -L.oy, L.w, L.h); f.globalCompositeOperation = 'source-over'; f.globalAlpha = 1; }
            f.restore();
          }
        }
      }
      // Clasp at the bottom with a small gem.
      f.fillStyle = radial(f, C - 1, C + R - 1, 0, 4, [[0, '#fff'], [.3, '#ff5a7a'], [1, '#6a0018']]); f.beginPath(); f.arc(C, C + R, 3.4, 0, TAU); f.fill();
      f.strokeStyle = '#f2c75a'; f.lineWidth = 1; f.stroke();
      // Slow light sweep around the wreath.
      const a = Math.PI / 2 + Math.sin(t * .35) * 2.2;
      sparkle(f, C + Math.cos(a) * R, C + Math.sin(a) * R, 5, .55 + .45 * Math.sin(t * 1.3), '255,245,210');
    } });

  // ---------- 10. Cyber HUD ring (tight) ----------
  DECOS.push({ group: 'front', name: 'Siber HUD', hint: 'Kenara oturan hedefleme halkası',
    init() {},
    draw(b, f, t) {
      glow(b, C, C, 64, '0,200,255', .2);
      const ring = (r, w, segs, gap, rot, col, a) => { f.strokeStyle = `rgba(${col},${a})`; f.lineWidth = w;
        for (let i = 0; i < segs; i++) { const s0 = rot + i * TAU / segs; f.beginPath(); f.arc(C, C, r, s0, s0 + TAU / segs - gap); f.stroke(); } };
      f.save(); f.globalCompositeOperation = 'lighter'; f.shadowColor = '#00e5ff'; f.shadowBlur = 5;
      ring(AR + 1.5, 1, 1, 0, 0, '0,229,255', .6);
      ring(AR + 5, 2.2, 6, .5, t * .2, '0,229,255', .85);
      ring(AR + 8.5, .8, 3, 1.3, -t * .14, '255,60,200', .85);
      f.strokeStyle = 'rgba(0,229,255,.5)'; f.lineWidth = .6;
      for (let i = 0; i < 60; i++) { const a = i * TAU / 60 - t * .04, l = i % 5 ? 1.2 : 2.4; f.beginPath(); f.moveTo(C + Math.cos(a) * (AR + 9.5), C + Math.sin(a) * (AR + 9.5)); f.lineTo(C + Math.cos(a) * (AR + 9.5 + l), C + Math.sin(a) * (AR + 9.5 + l)); f.stroke(); }
      const sw = t * .5;
      for (let k = 0; k < 16; k++) { f.strokeStyle = `rgba(0,229,255,${.4 * (1 - k / 16)})`; f.lineWidth = 2.6; f.beginPath(); f.arc(C, C, AR + 5, sw - k * .035, sw - k * .035 + .035); f.stroke(); }
      for (let i = 0; i < 2; i++) { const a = t * (.25 + i * .1) + i * 2.6; glow(f, C + Math.cos(a) * (AR + 8.5), C + Math.sin(a) * (AR + 8.5), 4, i ? '255,60,200' : '0,229,255', .9); }
      f.restore();
    } });


const DECO_KEYS = {'Kedi Kulakları': 'cat-ears', 'Kitsune Kuyrukları': 'kitsune', 'Mavi Kelebekler': 'morpho', 'Cehennem Ateşi': 'hellfire', 'Sakura Çelengi': 'sakura-wreath', 'Kraliyet Tacı': 'royal-crown', 'Altın Defne': 'golden-laurel', 'Siber HUD': 'cyber-hud'};
export const DECORATION_FX = Object.fromEntries(DECOS.filter((d) => DECO_KEYS[d.name]).map((d) => [DECO_KEYS[d.name], d]));
export const DECO_C = C, DECO_AR = AR;
